import { type Config, config as usConfig } from './en';

export const config: Config = {
  seo: usConfig.seo,
  layout: usConfig.layout,
  hero: usConfig.hero,
  products: {
    ...usConfig.products,
    darkBackground: true,
  },
  customersReviews: {
    ...usConfig.customersReviews,
    darkBackground: true,
    tweetsBackBandColor: 'f7f7f7',
  },
  instantEverything: usConfig.instantEverything,
  switching: usConfig.switching,
  howItWorks: usConfig.howItWorks,
  trust: usConfig.trust,
};
